import React from 'react';
import { withTheme } from 'styled-components';


const InfoIcon = withTheme(({ width, height, theme }) => {
  return (
    <>
      <svg
        width={`${width}px`}
        height={`${height}px`}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 0.5C5.20156 0.5 0.5 5.20156 0.5 11C0.5 16.7984 5.20156 21.5 11 21.5C16.7984 21.5 21.5 16.7984 21.5 11C21.5 5.20156 16.7984 0.5 11 0.5ZM11 19.7188C6.18594 19.7188 2.28125 15.8141 2.28125 11C2.28125 6.18594 6.18594 2.28125 11 2.28125C15.8141 2.28125 19.7188 6.18594 19.7188 11C19.7188 15.8141 15.8141 19.7188 11 19.7188Z"
          fill={theme.colors.default.primary}
        />
        <path
          d="M9.875 6.875C9.875 7.17337 9.99353 7.45952 10.2045 7.6705C10.4155 7.88147 10.7016 8 11 8C11.2984 8 11.5845 7.88147 11.7955 7.6705C12.0065 7.45952 12.125 7.17337 12.125 6.875C12.125 6.57663 12.0065 6.29048 11.7955 6.0795C11.5845 5.86853 11.2984 5.75 11 5.75C10.7016 5.75 10.4155 5.86853 10.2045 6.0795C9.99353 6.29048 9.875 6.57663 9.875 6.875ZM11.5625 9.5H10.4375C10.3344 9.5 10.25 9.58438 10.25 9.6875V16.0625C10.25 16.1656 10.3344 16.25 10.4375 16.25H11.5625C11.6656 16.25 11.75 16.1656 11.75 16.0625V9.6875C11.75 9.58438 11.6656 9.5 11.5625 9.5Z"
          fill={theme.colors.default.primary}
        />
      </svg>
    </>
  );
});

export { InfoIcon };
